import { PopoverController } from '@ionic/angular';
import { TieDetailsService } from './../../../ties/tie-details/tie-details.service';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TieService } from '../../../_core/services/tie.service';
import { Tie } from '../../../_shared/models/tie.model';

interface RoundSettings {
  roundNumber: FormControl<number>;
  roundPosition: FormControl<number>;
}

@Component({
  standalone: false,
  selector: 'app-round-settings',
  templateUrl: './round-settings.component.html',
  styleUrls: ['./round-settings.component.scss'],
})

export class RoundSettingsComponent implements OnInit {
  @Input({ required: true }) tie: Tie;
  private tieService = inject(TieService);
  private popoverController = inject(PopoverController);

  form = new FormGroup<RoundSettings>({
    roundNumber: new FormControl(1),
    roundPosition: new FormControl(1)
  })

  constructor() { }

  ngOnInit() {}

  submit() {
    this.tieService
      .update(this.tie._id, this.form.value)
      .subscribe({
        next: () => {
          this.popoverController.dismiss()
        }
      })
  }

}
